import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import Home from './components/feature/home/Home';
import ArticleEdit from './components/feature/article/ArticleEdit';
import ArticleView from './components/feature/article/ArticleView';
import DocumentIndex from './components/feature/doc-index/DocumentIndex';
import SearchResults from "./components/feature/search/SearchResults";

Vue.use(VueRouter);

const Access = {
	PUBLIC: 'PUBLIC',
}

const router = new VueRouter({
	mode: 'history',
	base: 'console/doc/v1',
	routes: [
		{
			path: '/',
			component: Home,
			name: 'Home',
			meta: { access: Access.PUBLIC }
		},
		{
			path: '/article-edit',
			component: ArticleEdit,
			name: 'ArticleEdit',
			beforeEnter: (to, from, next) => {
				if (store.getters.isEditor) {
					next();
				} else {
					next({ path: '/article-view', query: to.query });
				}
			}
		},
		{
			path: '/article-view',
			component: ArticleView,
			name: 'ArticleView',
			meta: { access: Access.PUBLIC }
		},
		{
			path: '/index',
			component: DocumentIndex,
			name: 'DocumentIndex',
			meta: { access: Access.PUBLIC }
		},
		{
			path: '/search-results',
			component: SearchResults,
			name: 'SearchResults',
			meta: { access: Access.PUBLIC }
		}
	]
})

export default router;